/* global BRAND */

import { createGlobalStyle } from 'styled-components'
import { loadFont } from 'loankeeper-common/helpers/styles'

// eslint-disable-next-line import/no-dynamic-require
const theme = require(`../brands/${BRAND}/theme.json`)

const colors = {
  green: '#1FDA9A',
  blue: '#0DC9F7',
  pink: '#FF66CC',
  red: '#ED1C24',
  yellow: '#FFC33C',
  grey: '#7F7F7F',
  black: '#333333',
  ink: '#0241E2',
}

const GlobalStyle = createGlobalStyle`
  :root {
    --color-primary: ${theme.primaryColor || '#2185D0'};
    --color-primary-hover: ${theme.primaryColorHover || '#1279c6'};
    --color-window-background-header: ${theme.windowBackgroundHeaderColor};
    --color-window-background-footer: ${theme.windowBackgroundFooterColor};
    --color-window-button-hover: ${theme.windowButtonHoverColor};
    --color-modal-background-header: ${theme.modalBackgroundHeaderColor};
    --color-modal-background-footer: ${theme.modalBackgroundFooterColor};
    --color-modal-footer-action-button-background: ${theme.modalFooterActionButtonColor || '#e0e1e2'};
    --color-modal-footer-action-button-hover: ${theme.modalFooterActionButtonHoverColor || '#cacbca'};
    --color-modal-footer-action-button-text: ${theme.modalFooterActionButtonFontColor || 'rgba(0,0,0,.6)'};
    --color-navigation-background: ${theme.navigationBackgroundColor || '#fff'};
    --color-navigation-button-background-hover: ${theme.navigationButtonHoverBackgroundColor || 'lightgray'};
    --color-navigation-button-border: ${theme.navigationButtonBorderColor || 'lightgray'};
    --color-navigation: ${theme.navigationColor};
    --color-navigation-hover: ${theme.navigationHoverColor};
    --color-statusbar-background: ${theme.statusBarBackgroundColor || 'rgb(50, 50, 50)'};
    --color-statusbar-border: ${theme.statusBarBorderColor || '#000'};
    --color-statusbar-text: ${theme.statusBarColor || '#f2f2f2'};
    --color-window-header-text: ${theme.windowHeaderColor};
    --color-table-key: ${theme.tableKeyColor || 'rgb(33, 133, 208)'};
    --color-loading-overlay-background: ${theme.loadingOverlayBackgroundColor || 'rgba(255, 255, 255, 0.8)'};
    --color-loading-overlay-box-shadow: ${theme.loadingOverlayBoxShadowColor || 'rgba(0, 0, 0, 0.7)'};
  }

  body {
    ${loadFont(theme.bodyFont || "14px 'BPG Algeti', sans-serif", false)}
    background-color: #dcdcdc;
    overflow: hidden;
    line-height: 19px;
  }

  p.header-text{
    ${loadFont(theme.lkModalHeaderFont)};
  }
  
  button {
    cursor: pointer;
  }

  @media (max-height: 768px) {
    .modal-sm {
      height: 530px !important;
      max-height: calc(100vh - 143px);
    }
  }

  .capital, .header, .ui.menu {
    ${loadFont(theme.LKHeaderFont || "14px 'BPG Nino Mtavruli'")}
  }

  .ui.header {
    font-weight: 700 !important;
  }

  .navigation {
    background-color: var(--color-navigation-background);

    .navigation-dropdown {
      :not(:last-child) {
        border-right: 1px solid var(--color-navigation-button-border);
      }

      .navigation-item {
        background: var(--color-navigation-background);
        color: var(--color-navigation);
        ${loadFont(theme.navigationFont || "14px 'BPG Nino Mtavruli'")};

        &:hover {
          background-color: var(--color-navigation-button-background-hover);
          color: var(--color-navigation-hover);
        }
      }
    }
  }

  .ui.primary.active.button,
  .ui.primary.button .active.button:active,
  .ui.primary.buttons .active.button,
  .ui.primary.buttons .active.button:active {
    background: var(--color-primary-hover) !important;
    min-height: 31.5px !important;
  }

  .ui.primary.button:active,
  .ui.primary.buttons .button:active,
  .ui.primary.button:focus,
  .ui.primary.buttons .button:focus,
  .ui.primary.button:hover,
  .ui.primary.buttons .button:hover {
    background: var(--color-primary-hover) !important;
  }

  .ui.blue.button,
  .ui.blue.buttons .button {
    background: var(--color-primary) !important;
    min-height: 31.5px !important;
  }

  .ui.blue.button:hover,
  .ui.blue.buttons .button:hover {
    background: var(--color-primary-hover) !important;
  }

  .lk-window-hint,
  .lk-modal-header {
    color: var(--color-window-header-text) !important;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    height: 42px;

    .lk-icon {
      width: 28px;
      height: 28px;
    }
  }

  .lk-modal-actions-container .ui.button {
    background: var(--color-modal-footer-action-button-background) !important;
    color: var(--color-modal-footer-action-button-text) !important;
  }

  .lk-modal-actions-container .ui.button:hover,
  .lk-modal-actions-container .ui.button:focus {
    background: var(--color-modal-footer-action-button-hover) !important;
  }

  .lk-form-field,
  .lk-form-field *:not(i),
  .ui.input input {
    ${loadFont(theme.inputFont)}
  }

  #Content {
    .ui.button.lk-button {
      ${loadFont(theme.buttonFont || '12px BPG Algeti')}
    }
  }

  .primary-font {
    *:not(i):not(.lk-grid-container):not(.details-tab-slider-container) {
      ${loadFont(theme.primaryFont, false)}
    }
  }

  .lk-header {
    ${loadFont(theme.LKHeaderFont)}
  }

  .details-tab-slider-container .lk-slider__item {
    ${loadFont(theme.detailsTabsFont)}
  }

  .ui.page.dimmer {
    perspective: none;
    z-index: 999;
  }

  .priority-modals .ui.page.dimmer {
    z-index: 1000;
  }
 
  .ui.page.dimmer.inverted {
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .passed-field input {
    background-color: #ffffd8 !important;
  }

  input.passed-field {
    background-color: #ffffd8 !important;
  }

  .passed-field.dropdown {
    background-color: #ffffd8 !important;
  }

  ::placeholder {
    font-style: italic;
  }

  .lk-window {
    .lk-window-header {
      background: var(--color-window-background-header);

      .lk-label,
      .lk-window-header__hint {
        font-weight: bold;
        color: var(--color-window-header-text) !important;
        ${loadFont(theme.windowHeaderFont)};
      }

      .lk-button.close-btn {
        padding-right: 0;

        .lk-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          margin: 0;
        }
      }
    }
  }

  .ui.action.input > .ui.lk-button {
    padding: 5px 15px;
  }

  .lk-grid-container .ag-theme-blue {
    .ag-row-selected {
      background-color: white;
    }

    .ag-row-odd {
      background-color: #fff;
    }

    .ag-tool-panel {
      display: none;
    }

    .ag-column-select-header {
      display: flex;
    }

    .ag-filter-body {
      margin-left: 4px;
    }

    .ag-column-tool-panel {
      margin-top: 4px;
      margin-left: 4px;
    }
  }

  .is-noPadding {
    padding: 0px !important;
  }

  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  ::-webkit-scrollbar-track {
    background:#d3d3d3;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background:#a9a4a4;
  }

  .ui.button.lk-justify-center div {
    justify-content: center;
  }

  .error-modal {
    z-index: 10000 !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .ui.modals {
    justify-content: center !important;

    > .modal {
      margin: 0 !important;
    }
  }

  .ui.modal {
    width: auto;
    background: transparent;
    justify-content: center;
    margin: 0;
    
    > .close {
      display: none;
    }
  }

  .ui.labeled.input > .label:not(.corner) {
    padding: .5833em .833em;
  }

  .ui.table td {
    padding: 5px;
  }

  .ui.progress {
    .bar {
      min-width: initial;
    }

    &.ProgressBar--red .bar {
      background: #ED1C24;
    }

    &.ProgressBar--yellow .bar {
      background: #FFC33C;
    }

    &.ProgressBar--green .bar {
      background: #1FDA9A;
    }

    &.ProgressBar--blue .bar {
      background: #0DC9F7;
    }
  }

  .App {
    display: grid;
    grid-template-rows: 35px auto 37px 27px;
    grid-template-areas:
        "navigation"
        "content"
        "tabs"
        "status-bar";
    height: 100vh;

    .App-content {
      padding: 5px 0;
      overflow: hidden;
      background-color: #dcdcdc;
      z-index: 99;
    }
  }

  .ui.disabled.dropdown,
  .ui.dropdown .menu>.disabled.item {
    opacity: 0.50;
  }

  .ui.disabled.input,
  input[disabled],
  .ui.input input[disabled] {
    opacity: 0.75;
  }

  .ui.checkbox input[disabled]~.box:after,
  .ui.checkbox input[disabled]~label,
  .ui.disabled.checkbox .box:after,
  .ui.disabled.checkbox label {
    opacity: 0.55;
    outline: none;
  }

  .ui.disabled.checkbox label:hover::before,
  .ui.disabled.checkbox input:focus ~ label:before {
    border-color: #D4D4D5;
  }

  .LKError {
    border: 1px solid ${colors.red} !important;
    color: ${colors.red} !important;
    padding: 6px 10px !important;

    :before {
      border: 1px solid ${colors.red};
      border-top: none;
      border-left: none;
    }

    &.bottom {
      :before {
        border: 1px solid #ED1C24;
        border-top: 1px solid #ED1C24 !important;
        border-left: 1px solid #ED1C24 !important;
        border-bottom: none !important;
        border-right: none !important;
      }
    }

  }

  .bottom.LKError {
    :before {
      border: 1px solid ${colors.red};
      border-top: none;
      border-left: none;
    }
  }

  .visible.transition.LKError--hidden {
    display: none !important;
  }

  .failed-field, .failed-field * {
    background-color: #fff6f6 !important;
    color: #9f3a38 !important;
    border-color: #e0b4b4 !important;
  }

  .failed-field button {
    border: 1px solid #e0b4b4 !important;
  }

  .fixed-height {
    overflow-y:auto;
  }

  h5.ui.header.lk-window-hint.lk-header {
    margin-top: 0;
    vertical-align: baseline;
  }

  @media (max-width: 1400px) {
    .Navigation-item {
      padding: 5px 8px;
    }

    .fixed-height {
      height:480px !important;
      overflow-y:auto;
    }
  }

  .Login {
    margin-top: 4vh;
    margin-bottom: 4vh;
    height: 92vh;
    background-color: white;
    background-image: url('/static/images/login-background.jpg');
    background-size: cover;
    padding-top: 40px;

    .Login-logo {
      width: 55%;
      display: block;
      margin: auto;
    }
  }

  .ag-dnd-ghost {
    // probably big enough value, might complicate things
    z-index: 9999;
  }

  .animated {
    -webkit-animation-duration: 250ms;
    animation-duration: 250ms;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .bold {
    font-weight: 700!important;
  }

  input[type="date"] {
    padding: 3px!important;
  }

  .active {
    display: block;
  }

  .custom-small-modal {
    width: 400px !important;
  }

  .ui table td {
    padding: 5px !important;
    min-width: 200px !important;
  }

  .DayPickerInput {
    width: 100%;
  }

  .DayPicker {
    height:280px !important;
    overflow:hidden;
  }

  .DayPickerInput-Overlay {
    z-index: 5;
  }

  .DayPicker-wrapper {
    z-index: 1;
    background-color: white;
    color: black;
    height: 100%;
    
    &:focus {
      outline: none;
    }
  }

  .DayPickerInput {
    width: 100%;

    input {
      width: 100%;
      padding: 0.5em !important;
      border: 1px solid rgba(34,36,38,.15);
      border-radius: .28571429rem;
      outline: none;
      min-height: 33px !important;
      line-height: 1.2142em;
    }
  }

  .DayPicker-Day--selected {
    background-color: initial !important;
    position: relative;
  }

  .DayPicker-Day:hover {
    background-color: initial !important;
  }

  .DayPicker-Day {
    position: relative;
  }

  .DayPicker-Caption > div {
    font-size: 14px;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--outside)::after {
    content: "";
    display: block;
    width: 30px;
    height: 30px;
    background-color: #4a90e2;
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 100%;
    z-index: -1;
  }


  .w-pos-relative {
    position:relative;
  }

  .w-pos-relative .ui[class*="left icon"].input>input {
    padding-right: 2rem !important;
  }

  .ui.label.input-second-icon--label {
    background-color:transparent !important;
    border: 1px solid rgba(34,36,38,.15);
    border-left: 0;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    border-top: 0;
    border-bottom: 0;
  }

  .ui.label.input-second-icon--label i {
    margin: 0;
    vertical-align: -webkit-baseline-middle;
  }

  @media(max-width:1500px) {
    .correctRight > .navigation-child-menu {
      right:0;
    }
  }

  .search-form-container {
    *:not(i) {
      ${loadFont(theme.searchPanelFont)};
    }

    .lk-form-field,
    .lk-form-field *:not(i):not( div[fieldtype="date"] input) {
      ${loadFont(theme.searchPanelFont)};
    }
  }

  .lk-slider .ui.button.lk-slider__item--focused .lk-slider__menu-item {
    border-color: var(--color-modal-background-header);
  }
  
  .table-key {
    font-size: 1.071em;
    color: var(--color-table-key);
  }

  .lk-icon-button {
    ${loadFont(theme.buttonFont)};

    *:not(i) {
      ${loadFont(theme.buttonFont)};
    }
  }

  .navigation .ui.button.lk-button {
    min-width: initial;
  }

  .lk-window-footer {
    background-color: var(--color-window-background-footer);
  }

  hr {
    width: 100%;
    border: 0;
    border-top: 1px solid lightgray;
    margin: 5px 0;
  }

  .text-right {
    text-align: right;
  }

  .text-left {
    text-align: left;
  }

  .vertical-middle {
    vertical-align: middle;
  }
`

export default GlobalStyle
